import React from 'react';
import { Box, Inline } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import SearchInputModalTrigger from '../search/SearchPopover/SearchInputModalTrigger';
import { HeaderSearchBarProps } from './types';

export const HeaderSearchBar = ({
  headerSearchBarText,
  showHeaderSearchBar,
}: HeaderSearchBarProps) => {
  if (!showHeaderSearchBar) {
    return null;
  }

  return (
    <Box>
      <Box
        paddingX={8}
        paddingTop={20}
        paddingBottom={16}
        testID="header-search-bar"
      >
        <Inline
          alignItems="center"
          borderColor={BrandColor.Silver}
          borderRadius={100}
          borderStyle="solid"
          borderWidth={1}
          paddingLeft={16}
        >
          <SearchInputModalTrigger
            text={headerSearchBarText || undefined}
            source="pro_profile_header"
            showHeaderSearchBar
          />
        </Inline>
      </Box>
    </Box>
  );
};
